import {
  withErrorBoundary,
  UnauthorisedAccess,
  AccessControl
} from '@nile/components';
import React from 'react';
import TriageInsightsCard from '@nile/mangifera/src/Containers/CardContainers/TriageInsightsCard';
import PatchInsightsCard from '@nile/mangifera/src/Containers/CardContainers/PatchInsightsCard';

const MonicaInsights = () => {
  return (
    <div
      id="monica-insights-workspace"
      className="pt20 pl20 w100 pr-20 fhp scroll pb-100"
    >
      <TriageInsightsCard />

      <AccessControl
        roleToCheck="patchViews.view"
        render={<PatchInsightsCard />}
        fallback={<UnauthorisedAccess />}
      />
    </div>
  );
};

export default withErrorBoundary(MonicaInsights);
